import React from 'react';

import { useBreakpoint } from 'common/hooks';

import RackcingLogo from 'resources/logo.svg';

const Logo = () => {
    const breakpoint = useBreakpoint();
    const width = ['sm', 'xs'].includes(breakpoint) ? '30px' : '35px';
    return <img src={RackcingLogo} style={{ maxWidth: 'initial', width }} />;
};

export default Logo;
